document.addEventListener("DOMContentLoaded", function () {
    const packNumberEl = document.querySelector("h3 span[pack-number]");
    const itemNumberEl = document.querySelector("h3 span[item-number]");
    const oneTimeLabels = document.querySelectorAll(".product-form-block .time-option");
    const addButton = document.querySelector(".bundle-add-to-cart");
    const mobileClick = document.querySelector(".bundle-builder__form");
    let bundleTotalPrice = 0;

    // Display discount per pack size (percent). Packs not listed use the number in their badge.
    const PACK_DISCOUNTS = { 3: 17.2690763, 4: 21.8875502, 5: 23.0522088 };
    // Price used for empty slots: the highest price among the bundle's products.
    const baseProductPrice = Math.max(0, ...[...document.querySelectorAll('.bundle-builder__product .btn__wrapper')]
        .map(btn => parseFloat(btn.getAttribute('product-price')) || 0));

    // The bundle form is a bottom panel on mobile (same breakpoint as the header toggle).
    const isMobilePanel = () => window.matchMedia('(max-width: 749px)').matches;

    // Initialize pack number and price on page load
    initializePackNumber();
    updateTotalPrice();
    updateTimeOptionVisibility();
    // Mobile: the panel starts open
    if (mobileClick && isMobilePanel()) mobileClick.classList.add('active');
    
    document.addEventListener("click", function (e) {
        const btn = e.target.closest(".btn__wrapper");
        if (btn) {
            e.preventDefault();
            handleAddButton(btn);
            return;
        }
        const plusBtn = e.target.closest(".quantity_pop .plus");
        if (plusBtn) {
            e.preventDefault();
            handlePlusButton(plusBtn);
            return;
        }
        const minusBtn = e.target.closest(".quantity_pop .minus");
        if (minusBtn) {
            e.preventDefault();
            handleMinusButton(minusBtn);
            return;
        }
        const removeBtn = e.target.closest(".bundle-builder__item-remove");
        if (removeBtn) {
            handleRemoveButton(removeBtn);
            return;
        }
    });
    
    const packInputs = document.querySelectorAll('.bundle-pack-size input[name="product-option"]');
    packInputs.forEach(input => {
        input.addEventListener('change', function () {
            handlePackSizeChange(this);
        });
    });
    
    function initializePackNumber() {
        const activePackSize = document.querySelector('.bundles-sizes.is-active');
        if (activePackSize) {
            const packText = activePackSize.getAttribute('data-pack-size');
            const packSize = extractPackNumber(packText);
            updatePackNumber(packSize);
        }
    }
    
    function extractPackNumber(packText) {
        // Extract number from text like "2-Pack", "3-Pack", "4-Pack", "5-Pack"
        const match = packText.match(/(\d+)/);
        return match ? parseInt(match[1]) : 3;
    }
    
    function handleAddButton(btn) {
        const productId = btn.getAttribute("product-id");
        const productPrice = parseFloat(btn.getAttribute("product-price")) || 0;
        const cardInfo = btn.closest(".card__information");
        const qtyBox = cardInfo.querySelector(".quantity_pop");
        const slot = activateNextBundleSlot(productId, productPrice);
        if (slot) {
            btn.style.display = "none";
            qtyBox.style.display = "";
            qtyBox.classList.add('active');
            updateItemNumber();
            updateTotalPrice();
            updateTimeOptionVisibility();
        }
    }
    
    function handlePlusButton(plusBtn) {
        const productId = plusBtn.getAttribute("product-id");
        const productPrice = parseFloat(plusBtn.getAttribute("product-price")) || 0;
        const emptySlot = getNextEmptyBundleSlot(productId);
        if (!emptySlot) {
            plusBtn.classList.add('disabled');
            return;
        }
        activateNextBundleSlot(productId, productPrice);
        updateItemNumber();
        updateTotalPrice();
        updateTimeOptionVisibility();
    }
    
    function handleMinusButton(minusBtn) {
        const qtyBox = minusBtn.closest(".quantity_pop");
        const qtyInput = qtyBox.querySelector("input");
        const cardInfo = minusBtn.closest(".card__information");
        const addBtn = cardInfo.querySelector(".btn__wrapper");
        const productId = addBtn.getAttribute("product-id");
        removeLastBundlePreview(productId);
        if (countActiveProductSlots(productId) === 0) {
            qtyInput.value = 1;
            qtyBox.style.display = "none";
            qtyBox.classList.remove('active');
            addBtn.style.display = "";
        }
        updateItemNumber();
        updateTotalPrice();
        updateTimeOptionVisibility();
    }
    
    function handleRemoveButton(removeBtn) {
        const item = removeBtn.closest(".bundle-builder__item");
        const productId = removeBtn.getAttribute("product-id");
        const preview = item.querySelector(`.bundle-builder__preview[bundle-preview="${productId}"].active`);
        const imgContainer = item.querySelector(".item-img");
        if (preview) preview.classList.remove("active");
        if (imgContainer) imgContainer.style.display = "";
        item.classList.remove("active");
        updateProductQuantityUI(productId);
        updateGlobalButtons();
        updateItemNumber();
        updateTotalPrice();
        updateTimeOptionVisibility();
    }
    
    function handlePackSizeChange(input) {
        const activePackSize = input.closest('.bundles-sizes');
        const packText = activePackSize.getAttribute('data-pack-size');
        const selectedValue = extractPackNumber(packText);
        
        document.querySelectorAll('.bundles-sizes')
            .forEach(bs => bs.classList.remove('is-active'));
        activePackSize.classList.add('is-active');
        
        const itemsContainer = document.querySelector('.bundle-builder__items');
        const itemTemplate = itemsContainer.querySelector('.bundle-builder__item');
        const currentItems = itemsContainer.querySelectorAll('.bundle-builder__item').length;
        
        // Remove extra items when downsizing
        if (selectedValue < currentItems) {
            const itemsToRemove = currentItems - selectedValue;
            
            for (let i = 0; i < itemsToRemove; i++) {
                const lastChild = itemsContainer.lastElementChild;
                if (!lastChild) continue;
                
                // Click remove button if item is active
                const removeBtn = lastChild.querySelector(".bundle-builder__item-remove");
                if (removeBtn && lastChild.classList.contains('active')) {
                    removeBtn.click();
                }
                
                // Remove the element from DOM
                lastChild.remove();
            }
            
            // Update UI after all removals
            updateGlobalButtons();
            updateItemNumber();
            updateTotalPrice();
            updateTimeOptionVisibility();
        }
        
        // Add items when upsizing
        if (selectedValue > currentItems) {
            const toAdd = selectedValue - currentItems;
            
            for (let i = 0; i < toAdd; i++) {
                const clone = itemTemplate.cloneNode(true);
                clone.classList.remove("active");
                clone.querySelectorAll(".bundle-builder__preview")
                    .forEach(pre => pre.classList.remove("active"));
                
                const img = clone.querySelector(".item-img");
                if (img) img.style.display = "";
                
                const removeBtn = clone.querySelector(".bundle-builder__item-remove");
                if (removeBtn) removeBtn.removeAttribute("product-id");
                
                itemsContainer.appendChild(clone);
            }
        }
        
        updatePackNumber(selectedValue);
        updateGlobalButtons();
        updateItemNumber();
        updateTotalPrice();
        updateTimeOptionVisibility();
        // Mobile: choosing a pack closes the panel so the products can be picked
        if (mobileClick && isMobilePanel()) mobileClick.classList.remove('active');
    }
    
    function getBundleItems() {
        return document.querySelectorAll(".bundle-builder__item");
    }
    
    function getNextEmptyBundleSlot(productId) {
        const items = getBundleItems();
        for (let item of items) {
            if (!item.classList.contains("active")) {
                const preview = item.querySelector(`[bundle-preview="${productId}"]`);
                if (preview) return item;
            }
        }
        return null;
    }
    
    function activateNextBundleSlot(productId, productPrice) {
        const slot = getNextEmptyBundleSlot(productId);
        if (!slot) return null;
        const img = slot.querySelector(".item-img");
        const preview = slot.querySelector(`[bundle-preview="${productId}"]`);
        const removeBtn = slot.querySelector(".bundle-builder__item-remove");
        if (img) img.style.display = "none";
        if (preview) preview.classList.add("active");
        if (removeBtn) {
            removeBtn.setAttribute("product-id", productId);
            removeBtn.setAttribute("product-price", productPrice);
        }
        slot.classList.add("active");
        bundleTotalPrice += productPrice;
        updateGlobalButtons();
        return slot;
    }
    
    function removeLastBundlePreview(productId) {
        const items = [...getBundleItems()].reverse();
        for (let item of items) {
            const preview = item.querySelector(`.bundle-builder__preview[bundle-preview="${productId}"].active`);
            if (preview) {
                preview.classList.remove("active");
                item.classList.remove("active");
                item.querySelector(".item-img").style.display = "";
                updateGlobalButtons();
                return true;
            }
        }
        return false;
    }
    
    function countActiveProductSlots(productId) {
        let count = 0;
        document.querySelectorAll(".bundle-builder__item").forEach(item => {
            const preview = item.querySelector(`.bundle-builder__preview[bundle-preview="${productId}"].active`);
            if (preview) count++;
        });
        return count;
    }
    
    function updateProductQuantityUI(productId) {
        const card = document.querySelector(`.btn__wrapper[product-id="${productId}"]`)?.closest(".card__information");
        if (!card) return;
        const qtyBox = card.querySelector(".quantity_pop");
        const qtyInput = qtyBox.querySelector("input");
        const addBtn = card.querySelector(".btn__wrapper");
        const activeCount = countActiveProductSlots(productId);
        if (activeCount === 0) {
            qtyInput.value = 1;
            qtyBox.style.display = "none";
            qtyBox.classList.remove('active');
            addBtn.style.display = "";
        } else {
            qtyInput.value = activeCount;
            qtyBox.classList.add('active');
        }
    }
    
    function updateGlobalButtons() {
        const allItems = [...document.querySelectorAll(".bundle-builder__item")];
        const allActive = allItems.every(item => item.classList.contains("active"));
        document.querySelectorAll(".btn__wrapper").forEach(btn => {
            btn.disabled = allActive;
            btn.classList.toggle("disabled", allActive);
        });
        document.querySelectorAll(".quantity_pop .plus").forEach(plus => {
            plus.disabled = allActive;
            plus.classList.toggle("disabled", allActive);
        });
    }
    
    function updatePackNumber(newPack) {
        if (packNumberEl) packNumberEl.innerText = newPack;
    }
    
    function updateItemNumber() {
        const activeItems = document.querySelectorAll(".bundle-builder__item.active").length;
        if (itemNumberEl) itemNumberEl.innerText = activeItems;
    }
    
    function getCurrentPackSize() {
        const allItems = document.querySelectorAll(".bundle-builder__item");
        return allItems.length;
    }
    
    // Discount for the active pack as a decimal: PACK_DISCOUNTS, else the "Save N%" badge.
    function getPackDiscountRate(packSize) {
        if (PACK_DISCOUNTS[packSize] !== undefined) return PACK_DISCOUNTS[packSize] / 100;
        const badge = document.querySelector('.bundles-sizes.is-active .pack_badge');
        const match = badge?.textContent.match(/(\d+(?:\.\d+)?)%/);
        return match ? parseFloat(match[1]) / 100 : 0;
    }

    // Total for the whole pack: selected products at their own price, empty slots at the
    // bundle's product price, so a price shows even before any product is selected.
    function updateTotalPrice() {
        let newTotal = 0;
        const activeItems = document.querySelectorAll(".bundle-builder__item.active");
        activeItems.forEach(item => {
            const removeBtn = item.querySelector(".bundle-builder__item-remove");
            const productPrice = parseFloat(removeBtn?.getAttribute("product-price")) || 0;
            newTotal += productPrice;
        });
        const packSize = getCurrentPackSize();
        newTotal += Math.max(0, packSize - activeItems.length) * baseProductPrice;
        bundleTotalPrice = newTotal;

        const discountRate = getPackDiscountRate(packSize);
        const discountedPrice = bundleTotalPrice * (1 - discountRate);
        oneTimeLabels.forEach(label => {
            if (discountRate > 0) {
                label.innerHTML = `
                <span style="font-weight: bold;" class="discount-price" id="discount-price">${discountedPrice.toFixed(2)} ₪</span>
                <span style="margin-right: 8px; text-decoration: line-through;" id="total-price">${bundleTotalPrice.toFixed(2)} ₪</span>
                `;
            } else {
                label.innerHTML = `${bundleTotalPrice.toFixed(2)} ₪`;
            }
        });
    }
    
    function updateTimeOptionVisibility() {
        if (!oneTimeLabels && !addButton && !mobileClick) return;
        const allItems = [...document.querySelectorAll(".bundle-builder__item")];
        const allActive = allItems.every(item => item.classList.contains("active"));
        // The one-time purchase price always shows; the add-to-cart button's price only once the pack is full.
        oneTimeLabels.forEach(label => label.classList.toggle('show', allActive || !label.closest('.bundle-add-to-cart')));
        // Mobile panel opens when the pack is full; it is never force-closed here, so switching packs
        // or editing products with the panel open keeps the prices in view.
        if (allActive) {
            addButton.classList.remove('disabled');
            mobileClick.classList.add('active');
        } else {
            addButton.classList.add('disabled');
        }
    }
});

document.addEventListener('click', async function (event) {
  const target = event.target.matches('.bundle-add-to-cart')
    ? event.target
    : event.target.closest('.bundle-add-to-cart');
  if (!target) return;
  event.preventDefault();

  if (target.classList.contains('loading')) {
    return;
  }
  
  target.classList.add("loading");
  
  // The cart line for every pack is the "Your Bundles" product (variant set on the section).
  const bundleVariantId = (target.closest('bundle-builder') || document.querySelector('bundle-builder'))?.dataset.bundleVariantId;
  if (!bundleVariantId) {
    console.error('Bundle cart product is not configured (data-bundle-variant-id is empty)');
    target.classList.remove("loading");
    return;
  }

  const selectedPackElement = document.querySelector('.bundles-sizes.is-active');
  const selectedPackSize = selectedPackElement?.querySelector('.bundle-btn')?.textContent?.trim();
  const uniquePrefix = selectedPackElement?.dataset.uniquePrefix || 'Pack';

  // Hidden id that keeps every bundle a separate cart line (identical lines would merge).
  const bundleUniqueId = `${uniquePrefix}-${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;

  // Selected products, merged by variant. Prices are in agorot (Shopify cents).
  const itemsMap = {};
  document.querySelectorAll('.bundle-builder__items .bundle-builder__item.active .bundle-builder__preview.active').forEach(preview => {
    const variantId = Number(preview.getAttribute('variant-id'));
    if (!variantId) return;
    if (!itemsMap[variantId]) {
      itemsMap[variantId] = {
        product_id: Number(preview.getAttribute('bundle-preview')),
        variant_id: variantId,
        title: preview.dataset.title,
        price: Number(preview.dataset.price),
        quantity: 0
      };
    }
    itemsMap[variantId].quantity += 1;
  });
  const bundleItems = Object.values(itemsMap);
  if (!bundleItems.length) {
    target.classList.remove("loading");
    return;
  }

  // Properties starting with "_" are hidden in the cart drawer, cart page and checkout.
  const bundleLine = {
    variantId: bundleVariantId,
    quantity: 1,
    properties: {
      'Pack Size': selectedPackSize,
      // One product per line so mixed Hebrew/Latin titles read correctly in the RTL cart.
      'Items': bundleItems.map(item => `${item.quantity} x ${item.title}`).join('\n'),
      '_unique_id': bundleUniqueId,
      '_bundle_items': JSON.stringify(bundleItems),
      '_bundle_total': String(bundleItems.reduce((total, item) => total + item.price * item.quantity, 0))
    }
  };
  console.log('🆔 Bundle line:', bundleLine);

  await window.AddAlltoCartDrawer([bundleLine], target);
});
const BUNDLE_RETRY_DELAY = 1000;
const BUNDLE_ERROR_MESSAGE = 'לא הצלחנו להוסיף את המארז לעגלה, נסו שוב.';
const waitFor = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// True when every bundle (by its hidden _unique_id) is already a line in the cart.
function bundlesInCart(uniqueIds) {
  if (!uniqueIds.length) return Promise.resolve(false);
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => uniqueIds.every(id => cart.items.some(line => line.properties?._unique_id === id)))
    .catch(() => false);
}

// POST /cart/add.js. A network error, rate limit (429) or server error (5xx) is retried once,
// unless the cart shows the bundle was already added (so a lost response never adds it twice).
// A rejection such as "sold out" (other 4xx) is not retried.
async function addBundlesToCart(formData, uniqueIds) {
  let lastError;
  for (let attempt = 0; attempt < 2; attempt++) {
    if (attempt > 0) {
      await waitFor(BUNDLE_RETRY_DELAY);
      if (await bundlesInCart(uniqueIds)) return;
    }
    let response;
    try {
      response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
    } catch (networkError) {
      lastError = networkError;
      continue;
    }
    if (response.ok) return;
    const data = await response.json().catch(() => ({}));
    lastError = new Error(data.description || `Add to cart failed (${response.status})`);
    lastError.description = data.description;
    if (response.status !== 429 && response.status < 500) break;
  }
  // The request can fail after Shopify already added the line: trust the cart over the response.
  if (await bundlesInCart(uniqueIds)) return;
  throw lastError;
}

// Re-renders the cart drawer and cart count, then opens the drawer. The bundle is already in the
// cart at this point, so a failed refresh is retried once and otherwise only logged.
async function refreshBundleCartDrawer() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    return;
  }
  for (let attempt = 0; attempt < 2; attempt++) {
    if (attempt > 0) await waitFor(BUNDLE_RETRY_DELAY);
    try {
      const sections = await fetch('/?sections=cart-drawer,cart-icon-bubble').then(res => res.json());
      const drawerInner = cartDrawer.querySelector('.drawer__inner');
      if (drawerInner && sections['cart-drawer']) {
        drawerInner.innerHTML = new DOMParser()
          .parseFromString(sections['cart-drawer'], 'text/html')
          .querySelector('.drawer__inner').innerHTML;
      }
      const bubble = document.querySelector('.cart-count-section');
      if (bubble && sections['cart-icon-bubble']) {
        bubble.innerHTML = new DOMParser()
          .parseFromString(sections['cart-icon-bubble'], 'text/html')
          .querySelector('.cart-count-section').innerHTML;
      }
      break;
    } catch (error) {
      console.warn('Cart drawer refresh failed', error);
    }
  }
  cartDrawer.classList.remove('is-empty');
  cartDrawer.classList.add('active');
  cartDrawer.open();
}

// Inline message under the add-to-cart button (replaces the old browser alert).
function showBundleCartError(buttonElement, message) {
  const container = buttonElement?.closest('.product-form__buttons');
  if (!container) return;
  let errorElement = container.querySelector('.bundle-atc-error');
  if (!errorElement) {
    errorElement = document.createElement('p');
    errorElement.className = 'bundle-atc-error';
    errorElement.setAttribute('role', 'alert');
    buttonElement.insertAdjacentElement('afterend', errorElement);
  }
  errorElement.textContent = message;
  errorElement.hidden = !message;
}

window.AddAlltoCartDrawer = async function (itemsData, buttonElement) {
  if (!itemsData.length) {
    buttonElement?.classList.remove("loading");
    return;
  }
  const formData = new FormData();
  itemsData.forEach((item, index) => {
    formData.append(`items[${index}][id]`, item.variantId);
    formData.append(`items[${index}][quantity]`, item.quantity);
    Object.entries(item.properties || {}).forEach(([name, value]) => {
      if (value) formData.append(`items[${index}][properties][${name}]`, value);
    });
  });
  const uniqueIds = itemsData.map(item => item.properties?._unique_id).filter(Boolean);

  showBundleCartError(buttonElement, '');
  try {
    await addBundlesToCart(formData, uniqueIds);
  } catch (error) {
    console.error(error);
    showBundleCartError(buttonElement, error.description || BUNDLE_ERROR_MESSAGE);
    buttonElement?.classList.remove("loading");
    return;
  }
  await refreshBundleCartDrawer();
  buttonElement?.classList.remove("loading");
};